import Panel from './Panel'
import Heading from './Heading'
import Section from './Section'
import Footer from './Footer'
import AsyncPanel from './AsyncPanel'

export default Panel

export { Heading, Section, Footer, AsyncPanel }
